<form [formGroup]="form" (submit)="getReportDetails()">
    <div class="col-12 col-md-6">
        <ng-template class="row" ngFor let-input [ngForOf]="ssrsInputFields">
            <ng-container [ngSwitch]="input.Type">
                <ng-template [ngSwitchCase]="'TextBox'">
                    <div class="row">
                        <h5 class="col-6"><label [for]="input.Name"> {{input.DisplayName}}<span class="text-secondary" *ngIf="input.IsRequired"> *</span></label></h5>
                        <div class="col-6">
                            <input class="form-control" [formControlName]="input.Name" [type]="input.Type" [name]="input.Name" [value]="input.DefaultValue"
                                   [required]="input.IsRequired" [readonly]="input.IsReadonly" />
                            <div class="text-secondary" *ngIf="form.get(input.Name).invalid &&
                                    (form.get(input.Name).dirty || form.get(input.Name).touched)">
                                <div *ngIf="form.get(input.Name).errors.required">{{requiredFieldMessage}}</div>
                            </div>
                        </div>
                    </div>
                </ng-template>

                <ng-template [ngSwitchCase]="'DropDown'">
                    <div class="row">
                        <h5 class="col-6"><label [for]="input.Name"> {{input.DisplayName}}<span class="text-secondary" *ngIf="input.IsRequired"> *</span></label></h5>
                        <div class="col-6">
                            <select class="form-control" [formControlName]="input.Name" [name]="input.Name" [id]="input.Name" [required]="input.IsRequired">
                                <option *ngIf="!input.DefaultValue" [value]="null" [attr.selected]="true" [attr.disabled]="true">Select</option>
                                <option *ngFor="let option of input.Selections" [value]="option.Value" [attr.selected]="option.Value === input.DefaultValue ? true : null">{{option.Label}}</option>
                            </select>
                            <div class="text-secondary" *ngIf="form.get(input.Name).invalid &&
                                    (form.get(input.Name).dirty || form.get(input.Name).touched)">
                                <div *ngIf="form.get(input.Name).errors.required">{{requiredFieldMessage}}</div>
                            </div>
                        </div>
                    </div>
                </ng-template>

                <ng-template [ngSwitchCase]="'CalendarSelect'">
                    <div class="row">
                        <h5 class="col-6"><label [for]="input.Name"> {{input.DisplayName}}<span class="text-secondary" *ngIf="input.IsRequired"> *</span></label></h5>
                        <div class="col-6">
                            <input [formControlName]="input.Name" [name]="input.Name" [id]="input.Name" datepicker  (change)="onCalenderchange($event,input.Name)"
                                   [required]="input.IsRequired" class="datepicker" autocomplete="off" />
                          
                            <div class="text-secondary" *ngIf="form.get(input.Name).invalid &&
                                  (form.get(input.Name).dirty || form.get(input.Name).touched)">
                                <div *ngIf="form.get(input.Name).errors.required">{{requiredFieldMessage}}</div>
                            </div>
                        </div>
                    </div>
                </ng-template>

                <ng-template [ngSwitchCase]="'CheckBoxList'">
                    <div class="row">
                        <h5 class="col-6"><label [for]="input.Name"> {{input.DisplayName}}<span class="text-secondary" *ngIf="input.IsRequired"> *</span></label></h5>
                        <div class="col-6">
                            <div class="pb-3">
                                <ng-multiselect-dropdown [placeholder]="'Select'"
                                                         [settings]="dropdownSettings"
                                                         [data]="input.Selections"
                                                         [(ngModel)]="input.CheckboxListDefaultValues"
                                                         [formControlName]="input.Name">
                                </ng-multiselect-dropdown>
                            </div>
                            <div class="text-secondary" *ngIf="form.get(input.Name).invalid && form.get(input.Name).touched">
                                <div *ngIf="form.get(input.Name)?.errors?.required">{{requiredFieldMessage}}</div>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </ng-container>
        </ng-template>
        <button type="submit" class="btn btn-primary" [disabled]="!form.valid">Get Report</button><label class="large h6 pl-2"><span class="text-secondary"> *</span>{{requiredIndicatorMessage}}</label>
    </div>
</form>
<h3 [hidden]="!isLoading" class="text-center" [innerHTML]="loadingMessage"></h3>
<div *ngIf="!isLoading">
    <div *ngIf="reportHtml" class="row p-4">
        <div class="col-12 col-md-6">
            <h4 class="d-block">Download</h4>
            <button *ngIf="downloadType.includes(csvReportType)" class="btn btn-primary m-1" (click)="downloadReport(csvReportType)">CSV</button>
            <button *ngIf="downloadType.includes(xmlReportType)" class="btn btn-primary m-1" (click)="downloadReport(xmlReportType)">XML</button>
            <button *ngIf="downloadType.includes(pdfReportType)" class="btn btn-primary m-1" (click)="downloadReport(pdfReportType)">PDF</button>
            <button *ngIf="downloadType.includes(excelReportType)" class="btn btn-primary m-1" (click)="downloadReport(excelReportType)">EXCEL</button>
        </div>
        <ng-container *ngIf="!hidePagination">
            <div class="col-12 col-md-auto">
                <div *ngIf="reportHtml?.length>1" class="row justify-content-center justify-content-md-between align-items-center">
                    <div class="col-12 col-md-auto text-center">
                        <span>Showing {{endIndex}} of {{ reportHtml.length }} results</span>
                    </div>
                    <div class="col-auto">
                        <ngb-pagination [collectionSize]="reportHtml.length" [(page)]="page" [pageSize]="1" [maxSize]="3" [rotate]="true" [boundaryLinks]="false" (pageChange)="onChangePage($event)" aria-label="Default pagination">
                        </ngb-pagination>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
    <div *ngIf="style" [innerHTML]="style | keepHtml"></div>
    <ng-container *ngIf="!hidePagination">
        <div class="row ssrs" *ngFor="let element of reportHtml | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize">
            <div class="col-12" [innerHTML]="element.Value | keepHtml"></div>
        </div>
    </ng-container>
    <ng-container *ngIf="hidePagination">
        <div class="row ssrs" *ngFor="let element of reportHtml">
            <div class="col-12" [innerHTML]="element.Value | keepHtml"></div>
        </div>
    </ng-container>

    <ng-container *ngIf="!hidePagination && reportHtml">
        <div *ngIf="reportHtml?.length>1" class="row pt-4">
            <div class="col-12 col-md-6">&nbsp;</div>
            <div class="col-12 col-md-auto">
                <div *ngIf="reportHtml?.length>1" class="row justify-content-center justify-content-md-between align-items-center">
                    <div class="col-12 col-md-auto text-center">
                        <span>Showing {{endIndex}} of {{ reportHtml.length }} results</span>
                    </div>
                    <div class="col-auto">
                        <ngb-pagination [collectionSize]="reportHtml.length" [(page)]="page" [pageSize]="1" [maxSize]="3" [rotate]="true" [boundaryLinks]="false" (pageChange)="onChangePage($event)" aria-label="Default pagination">
                        </ngb-pagination>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</div>